import React from 'react';
import { useFeatureAccess } from '../../hooks/useFeatureAccess';
import TrialExpiredBanner from './TrialExpiredBanner';
import ComplimentaryExpiredBanner from './ComplimentaryExpiredBanner';

/**
 * Component that manages notifications for users without active Membership.
 * Lapsed users (real Stripe history) get the trial/reactivation banner;
 * former complimentary users get the dedicated complimentary-expired banner —
 * the two must never share copy (docs/complimentary-access-expiration.md §3.5).
 */
export default function LapsedUserNotifications() {
  const { isLapsed, isComplimentaryExpired } = useFeatureAccess();

  if (isComplimentaryExpired()) {
    return <ComplimentaryExpiredBanner source="global_banner" />;
  }

  if (isLapsed()) {
    return <TrialExpiredBanner />;
  }

  return null;
} 